import Seo from "@/components/Seo";
import SectionHeading from "@/components/SectionHeading";
import { Reveal, GoldLine, MaskedLine } from "@/components/Reveal";
import { openBooking } from "@/lib/api";
import { waLink, WA_MESSAGES } from "@/config/site";

const STEPS = [
    { n: "01", title: "Discover", copy: "Share your idea, inspiration or occasion. A photograph, a sketch, a memory — anything can be the beginning.", image: "/images/ring-box.jpg" },
    { n: "02", title: "Design", copy: "Refine the concept and details with our experts — metal, stones, proportions, budget — until it feels unmistakably yours.", image: "/images/goldsmith-1.jpg" },
    { n: "03", title: "Create", copy: "Our craftsmen bring the final vision to life, and your piece is revealed to you at the showroom.", image: "/images/hero-new.jpg" },
];

const CustomPage = () => (
    <main>
        <Seo
            title="Custom & Bespoke Jewellery in Amritsar | BSK Jewellers"
            siteName="BSK Jewellers"
            description="Create bespoke jewellery with BSK Jewellers, Rani Ka Bagh, Amritsar. Share your vision — our experts design and craft a piece around you. Discover, Design, Create."
            image="/images/rings-hands.jpg"
        />
        <section className="pt-40 pb-20 sm:pt-48 text-center px-5">
            <span className="eyebrow">Bespoke Atelier</span>
            <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl leading-[1.05] mt-6 max-w-4xl mx-auto">
                <MaskedLine delay={0.15}>Your Vision.</MaskedLine>
                <MaskedLine delay={0.3}><span className="italic gold-text">Our Craftsmanship.</span></MaskedLine>
            </h1>
            <Reveal delay={0.5}>
                <p className="text-sand text-sm sm:text-base max-w-xl mx-auto mt-7 leading-relaxed">
                    Have something special in mind? Discuss your vision with our jewellery experts and explore
                    the possibilities of a piece created around you.
                </p>
            </Reveal>
        </section>

        <section className="pb-24 sm:pb-32">
            <div className="max-w-[1300px] mx-auto px-5 sm:px-8 space-y-20 sm:space-y-28">
                {STEPS.map((s, i) => (
                    <div key={s.n} className={`grid grid-cols-1 md:grid-cols-2 gap-10 items-center ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`} data-testid={`custom-page-step-${s.n}`}>
                        <Reveal>
                            <div className="aspect-[4/3] overflow-hidden border border-gold/15 group">
                                <img src={s.image} alt={`${s.title} — bespoke jewellery at BSK Jewellers`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
                            </div>
                        </Reveal>
                        <div className={i % 2 ? "md:pr-10" : "md:pl-10"}>
                            <Reveal delay={0.1}>
                                <span className="font-serif italic text-7xl text-gold/15" aria-hidden="true">{s.n}</span>
                                <h2 className="font-serif text-3xl sm:text-4xl uppercase tracking-wide mt-2">{s.title}</h2>
                                <GoldLine delay={0.2} className="w-16 my-6" />
                                <p className="text-sand text-sm sm:text-base leading-relaxed max-w-md">{s.copy}</p>
                            </Reveal>
                        </div>
                    </div>
                ))}
            </div>
        </section>

        <section className="py-24 bg-charcoal/40 border-t border-gold/10 text-center">
            <div className="max-w-2xl mx-auto px-5">
                <SectionHeading title={<>Begin Something <span className="italic gold-text">Extraordinary</span></>} />
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                    <a href={waLink(WA_MESSAGES.custom)} target="_blank" rel="noreferrer" data-testid="custom-whatsapp-btn" className="bg-gold text-obsidian text-[11px] tracking-[0.25em] uppercase px-9 py-4 hover:bg-gold-bright transition-colors">
                        Start a Custom Enquiry
                    </a>
                    <button onClick={() => openBooking("Custom Jewellery")} data-testid="custom-book-btn" className="border border-gold/50 text-gold text-[11px] tracking-[0.25em] uppercase px-9 py-4 hover:bg-gold hover:text-obsidian transition-colors">
                        Book a Consultation
                    </button>
                </div>
            </div>
        </section>
    </main>
);

export default CustomPage;
